import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ColDef } from 'ag-grid-community';
import { GridConfig } from '../../_models/common/grid/grid-config';
import { AppGridComponent } from '../../shared/grid/grid-component/grid.component';

@Component({
    selector: 'app-claimant-details-component',
    templateUrl: './claimant-details-component.component.html',
    standalone: false
})
export class ClaimantDetailsComponentComponent implements OnInit {

  @ViewChild(AppGridComponent) gridComponent: AppGridComponent;

  gridColumnDefs: ColDef[];
  gridConfigItems: GridConfig;
  gridFilterStatus: number = 0;
  @Input() lstClaimants: any;
  @Input() panelHeader: string;
  @Output() callbackEvent = new EventEmitter<boolean>();
  constructor(
    private translate: TranslateService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.fnGridConfig();
  }

  fnGridConfig(){
    this.gridColumnDefs = [
      {
          headerName: this.translate.instant('cost_center_name'),
          field: 'employeeName',
          resizable: true,
          sortable: true,
          suppressHeaderMenuButton: true,
          minWidth: 100,

      },
      {
          headerName: this.translate.instant('label_email'),
          field: 'employeeEmail',
          resizable: true,
          sortable: true,
          suppressHeaderMenuButton: true,          
          minWidth: 100          
      }
  ];

  this.gridConfigItems = new GridConfig(
    false,
    false,
    "employeeName",
    "employeeId",
    0,
    false,
    [],
    true,
    true,
    false,
    null,
    'asc',
    40, 'no_data_availabe', null, null,
    false, false,
    '',
    '',
    true
  );

  setTimeout(() => {
    this.gridComponent.initializeGrid(false);
  }, 200);

}

onClosePanel(){
  this.callbackEvent.emit(false);
}

}
